export default {
    topics: [
        {
            title: ' contextPath ',
            href: 'p-HttpServletRequest-contextPath.html',
            attributes: { 'data-id': 'p-HttpServletRequest-contextPath' },
            menu: { hasChildren: false },
            tocID: 'p-HttpServletRequest-contextPath-d66e7694',
            topics: [],
        },
        {
            title: ' cookies ',
            href: 'p-HttpServletRequest-cookies.html',
            attributes: { 'data-id': 'p-HttpServletRequest-cookies' },
            menu: { hasChildren: false },
            tocID: 'p-HttpServletRequest-cookies-d66e7702',
            topics: [],
        },
        {
            title: ' forward ',
            href: 'm-HttpServletRequest-forward.html',
            attributes: { 'data-id': 'm-HttpServletRequest-forward' },
            menu: { hasChildren: false },
            tocID: 'm-HttpServletRequest-forward-d66e7710',
            topics: [],
        },
        {
            title: ' getBodyAsString ',
            href: 'm-HttpServletRequest-getBodyAsString.html',
            attributes: { 'data-id': 'm-HttpServletRequest-getBodyAsString' },
            menu: { hasChildren: false },
            tocID: 'm-HttpServletRequest-getBodyAsString-d66e7718',
            topics: [],
        },
        {
            title: ' getHeader ',
            href: 'm-HttpServletRequest-getHeader.html',
            attributes: { 'data-id': 'm-HttpServletRequest-getHeader' },
            menu: { hasChildren: false },
            tocID: 'm-HttpServletRequest-getHeader-d66e7726',
            topics: [],
        },
        {
            title: ' getParameter ',
            href: 'm-HttpServletRequest-getParameter.html',
            attributes: { 'data-id': 'm-HttpServletRequest-getParameter' },
            menu: { hasChildren: false },
            tocID: 'm-HttpServletRequest-getParameter-d66e7734',
            topics: [],
        },
        {
            title: ' getRemoteAddr ',
            href: 'm-HttpServletRequest-getRemoteAddr.html',
            attributes: { 'data-id': 'm-HttpServletRequest-getRemoteAddr' },
            menu: { hasChildren: false },
            tocID: 'm-HttpServletRequest-getRemoteAddr-d66e7742',
            topics: [],
        },
        {
            title: ' getUTF8Parameter ',
            href: 'm-HttpServletRequest-getUTF8Parameter.html',
            attributes: { 'data-id': 'm-HttpServletRequest-getUTF8Parameter' },
            menu: { hasChildren: false },
            tocID: 'm-HttpServletRequest-getUTF8Parameter-d66e7750',
            topics: [],
        },
        {
            title: ' method ',
            href: 'p-HttpServletRequest-method.html',
            attributes: { 'data-id': 'p-HttpServletRequest-method' },
            menu: { hasChildren: false },
            tocID: 'p-HttpServletRequest-method-d66e7758',
            topics: [],
        },
        {
            title: ' parameters ',
            href: 'p-HttpServletRequest-parameters.html',
            attributes: { 'data-id': 'p-HttpServletRequest-parameters' },
            menu: { hasChildren: false },
            tocID: 'p-HttpServletRequest-parameters-d66e7766',
            topics: [],
        },
        {
            title: ' pathInfo ',
            href: 'p-HttpServletRequest-pathInfo.html',
            attributes: { 'data-id': 'p-HttpServletRequest-pathInfo' },
            menu: { hasChildren: false },
            tocID: 'p-HttpServletRequest-pathInfo-d66e7775',
            topics: [],
        },
        {
            title: ' queryString ',
            href: 'p-HttpServletRequest-queryString.html',
            attributes: { 'data-id': 'p-HttpServletRequest-queryString' },
            menu: { hasChildren: false },
            tocID: 'p-HttpServletRequest-queryString-d66e7783',
            topics: [],
        },
        {
            title: ' requestURI ',
            href: 'p-HttpServletRequest-requestURI.html',
            attributes: { 'data-id': 'p-HttpServletRequest-requestURI' },
            menu: { hasChildren: false },
            tocID: 'p-HttpServletRequest-requestURI-d66e7791',
            topics: [],
        },
        {
            title: ' scheme ',
            href: 'p-HttpServletRequest-scheme.html',
            attributes: { 'data-id': 'p-HttpServletRequest-scheme' },
            menu: { hasChildren: false },
            tocID: 'p-HttpServletRequest-scheme-d66e7799',
            topics: [],
        },
        {
            title: ' serverName ',
            href: 'p-HttpServletRequest-serverName.html',
            attributes: { 'data-id': 'p-HttpServletRequest-serverName' },
            menu: { hasChildren: false },
            tocID: 'p-HttpServletRequest-serverName-d66e7807',
            topics: [],
        },
        {
            title: ' serverPort ',
            href: 'p-HttpServletRequest-serverPort.html',
            attributes: { 'data-id': 'p-HttpServletRequest-serverPort' },
            menu: { hasChildren: false },
            tocID: 'p-HttpServletRequest-serverPort-d66e7815',
            topics: [],
        },
        {
            title: ' serverURL ',
            href: 'p-HttpServletRequest-serverURL.html',
            attributes: { 'data-id': 'p-HttpServletRequest-serverURL' },
            menu: { hasChildren: false },
            tocID: 'p-HttpServletRequest-serverURL-d66e7823',
            topics: [],
        },
        {
            title: ' servletPath ',
            href: 'p-HttpServletRequest-servletPath.html',
            attributes: { 'data-id': 'p-HttpServletRequest-servletPath' },
            menu: { hasChildren: false },
            tocID: 'p-HttpServletRequest-servletPath-d66e7831',
            topics: [],
        },
    ],
};

